import { useQuery } from '@tanstack/react-query';

import { activityLogListSchema, IActivityLogEntry } from '../Interfaces/IActivityLog';
import { customFetcher } from './customFetcher';

interface UseActivityLogOptions {
    entityType?: string;
    action?: string;
    limit?: number;
}

export const useActivityLog = ({ entityType, action, limit = 100 }: UseActivityLogOptions = {}) => {
    return useQuery<IActivityLogEntry[], Error>({
        queryKey: ['activity-log', entityType ?? '', action ?? '', limit],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const query = new URLSearchParams();
            if (entityType) {
                query.set('entity_type', entityType);
            }
            if (action) {
                query.set('action', action);
            }
            query.set('limit', String(limit));
            const suffix = query.toString();
            const data = await customFetcher<unknown>({
                endpoint: `/activity-log/${suffix ? `?${suffix}` : ''}`,
            });
            return activityLogListSchema.parse(data);
        },
        initialData: [],
    });
};
